<div class="flex min-h-screen flex-col bg-gray-100">
	<p-blockui class="bg-gray-200/90!" [blocked]="showRoleDialog()" />

	<header class="sticky top-0 z-50 bg-white shadow-md">
		<app-header></app-header>
	</header>

	<div class="flex min-h-0 flex-1 items-stretch justify-center p-2 md:p-4">
		<main>
			<div class="min-h-0 flex-1 p-3">
				<router-outlet></router-outlet>
			</div>
		</main>
	</div>

	<footer>
		<app-footer></app-footer>
	</footer>

	<app-role-selection-dialog [visible]="showRoleDialog()" (visibleChange)="onRoleDialogVisibilityChange($event)" />
</div>
